import React from 'react';
import clsx from 'clsx';

import { FormItem } from '@/stories/components/Form/FormItem/FormItem';
import { Icon, type IconType } from '@/stories/atoms/Icon/Icon';
import styles from '@/stories/components/Form/Input/input.module.css';
import range from './slider.module.css';

export type FieldProps = {
  id: string,
  label: string,
  value?: string,
  required?: boolean,
  hideOptionnal?: boolean,
  hideLabel?: boolean,
  helpText?: string,
  icon?: IconType,
  variant?: 'secondary',
  marks?: number[],
  unit?: string,
}

export type InputProps = React.ComponentProps<'input'> & FieldProps

export const Slider = ({label, id, name, marks, unit, required = false, helpText, hideLabel, hideOptionnal, icon, variant, value, ...props}: InputProps) => {
  const {style, ...inputProps} = props

  return (
    <FormItem id={name || id} label={<>{label}<output aria-hidden className={range.output}>{value}{unit ? ` ${unit}` : value}</output></>} hideLabel={hideLabel} hideOptionnal={hideOptionnal} required={required} helpText={helpText} style={style}>
      <div className={clsx(styles.wrapper, icon && 'has-icon')}>
        
        {icon ? <Icon icon={icon} className={styles.icon}/> : null}
        <div className={clsx(range.wrapper)}>
          <input className={clsx(range.range, variant && range[variant])} id={id} type="range" value={value} required={required} {...inputProps}/>
          {marks ? (
            <div className={range.marks}>
              {marks.map((value, i) => <span key={i} className={range.mark}>{value}{unit ? ` ${unit}` : value}</span>)}
            </div>
          ) : null}
        </div>
      </div>
    </FormItem>
  )
};
